import * as React from "react";
import { SVGProps } from "react";

type AddNewRequestProps = SVGProps<SVGSVGElement> & {
    circleColor?: string;
    iconColor?: string;
};

const AddNewRequestIcon: React.FC<AddNewRequestProps> = (props) => {
    
    const { height = 32, width = 32, 
        circleColor = 'white', iconColor = 'black', ...rest } = props;

    // Remove custom props so they are not passed to the DOM
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <g id="add new request">
                <rect width={32} height={32} fill="white" />
                <g id="page">
                    <g id="back-page">
                        <path
                            d="M24 2H9C8.44772 2 8 2.44772 8 3V5H21C21.5523 5 22 5.44772 22 6V25.9659C22 25.9847 22.0153 26 22.0341 26H24C24.5523 26 25 25.5523 25 25V3C25 2.44772 24.5523 2 24 2Z"
                            fill="#D9D9D9"
                        />
                        <path
                            d="M8 5V3C8 2.44772 8.44772 2 9 2H24C24.5523 2 25 2.44772 25 3V25C25 25.5523 24.5523 26 24 26H22.0341C22.0153 26 22 25.9847 22 25.9659V6C22 5.44772 21.5523 5 21 5H8Z"
                            stroke="black"
                            strokeWidth={0.5}
                        />
                    </g>
                    <path
                        id="front-page"
                        d="M6 5H21C21.5523 5 22 5.44772 22 6V28C22 28.5523 21.5523 29 21 29H10.3837C10.1367 29 9.8984 28.9086 9.71477 28.7433L5.33104 24.7979C5.12032 24.6083 5 24.3381 5 24.0546V6C5 5.44772 5.44772 5 6 5Z"
                        stroke="black"
                        strokeWidth={0.5}
                    />
                    <path
                        id="fold-page"
                        d="M10 29V24.5C10 24.2239 9.77614 24 9.5 24H5"
                        stroke="black"
                        strokeWidth={0.5}
                        strokeLinecap="round"
                    />
                </g>
                <g id="lines">
                    <g id="Line 49" filter="url(#filter0_d_13_462)">
                        <line
                            x1={8.5}
                            y1={15.5}
                            x2={15.5}
                            y2={15.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 49_2" filter="url(#filter1_d_13_462)">
                        <line
                            x1={8.5}
                            y1={17.5}
                            x2={12.5}
                            y2={17.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 50" filter="url(#filter2_d_13_462)">
                        <line
                            x1={8.5}
                            y1={19.5}
                            x2={11.5}
                            y2={19.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 55" filter="url(#filter3_d_13_462)">
                        <line
                            x1={8.5}
                            y1={21.5}
                            x2={11.5}
                            y2={21.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 54" filter="url(#filter4_d_13_462)">
                        <line
                            x1={8.5}
                            y1={13.5}
                            x2={18.5}
                            y2={13.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 56" filter="url(#filter5_d_13_462)">
                        <line
                            x1={8.5}
                            y1={9.5}
                            x2={18.5}
                            y2={9.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 57" filter="url(#filter6_d_13_462)">
                        <line
                            x1={8.5}
                            y1={7.5}
                            x2={18.5}
                            y2={7.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                    <g id="Line 58" filter="url(#filter7_d_13_462)">
                        <line
                            x1={8.5}
                            y1={11.5}
                            x2={18.5}
                            y2={11.5}
                            stroke="black"
                            strokeLinecap="round"
                        />
                    </g>
                </g>
                <g id="circle">
                    <circle
                        id="inner-circle"
                        cx={20.5}
                        cy={23.5}
                        r={7.25}
                        fill={circleColor || "#D9D9D9"}
                        stroke={iconColor || "black"}
                        strokeWidth={0.5}
                    />
                    <path
                        id="icon"
                        d="M20.5 20V27M17 23.5H24"
                        stroke={iconColor || "black"}
                        strokeLinecap="square"
                    />
                </g>
            </g>
            <defs>
                <filter
                    id="filter0_d_13_462"
                    x={4}
                    y={15}
                    width={16}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter1_d_13_462"
                    x={4}
                    y={17}
                    width={13}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter2_d_13_462"
                    x={4}
                    y={19}
                    width={12}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter3_d_13_462"
                    x={4}
                    y={21}
                    width={12}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter4_d_13_462"
                    x={4}
                    y={13}
                    width={19}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter5_d_13_462"
                    x={4}
                    y={9}
                    width={19}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter6_d_13_462"
                    x={4}
                    y={7}
                    width={19}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
                <filter
                    id="filter7_d_13_462"
                    x={4}
                    y={11}
                    width={19}
                    height={9}
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity={0} result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy={4} />
                    <feGaussianBlur stdDeviation={2} />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                    />
                    <feBlend
                        mode="normal"
                        in2="BackgroundImageFix"
                        result="effect1_dropShadow_13_462"
                    />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="effect1_dropShadow_13_462"
                        result="shape"
                    />
                </filter>
            </defs>
        </svg>
    );
}

export default AddNewRequestIcon;
